import { useEffect } from "react";
import "./App.css";

function App() {
  useEffect(() => {
    const detectDeviceAndRedirect = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // iOS device detected
        window.location.href =
          "https://apps.apple.com/lk/app/ceylon-edge/id6737160996";
      } else if (/android/i.test(userAgent)) {
        // Android device detected
        window.location.href =
          "https://play.google.com/store/apps/details?id=lk.ceylonedge.app";
      } else {
        // Other OS or can't detect
        window.location.href = "https://ceylonedge.lk";
      }
    };

    detectDeviceAndRedirect();
  }, []);

  return null;
}

export default App;
